import type { FaireProductEntity } from "../../entity_types/product";

export const p_uqf5z6dyqn: FaireProductEntity = {
  token: "p_uqf5z6dyqn",
  type: "product",
  name: "Bronzite Spheres - 40mm (Approx. 1 Pound Bag)",
  brandToken: "b_4w78fajgal",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/04d06307aef28796b4e6a794f9957917baba3d0fb7d8982e74b20372b6f882a7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/de8e9c8204b6dfedd61c26abc9059a193ba71971524f676ebd02d3f4ca56a3bd.jpeg",
    "https://cdn.faire.com/fastly/9836614e9ad76b703e72d9193fb00b40174bcccedf33c0292afe0b2d9dcf5dab.jpeg",
    "https://cdn.faire.com/fastly/1905de27953040170ff4ab4c3d771556a1c3fa32d0219a7c33f18c81141d488a.jpeg",
    "https://cdn.faire.com/fastly/414cfdd72238feab9069c8f4a924677b5724e542daf6ae6f2ab64146e1457e27.jpeg",
    "https://cdn.faire.com/fastly/125a2786af5bb17c32285227b10fee28306b9d80ef1831fcdd4edd7b531709a9.jpeg",
    "https://cdn.faire.com/fastly/c235126a0f3a6f90fc882127d389194696ae8a6be12561e54bb57dbbd0e167d8.jpeg",
    "https://cdn.faire.com/fastly/5fd73cf8b57d16e63ac0991a41913db2d8bd0b38651fd6363d5555158150baa7.jpeg",
  ],
  priceDollars: 62.36,
  description:
    "Beautiful Bronzite Gemstone 40mm Spheres sold in 1 Pound increments.\n\n*Approximately 4-5 Spheres per Pound. \n*40mm diameter\n*Sold in  Approximate 1 Pound increments.\n*All natural gemstones\n\nThis picture is an representation of the type and quality of the gemstone you will be receiving.  As you know, there are slight variations due to the natural character of this product.",
  tags: [],
  msrpDollars: 124.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:40.840Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
